var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.595,
    height: 83.127,
    viewBox: "0 0 242.595 83.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 178.615,
    height: 30.306,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(-1109.491 -1057.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 242.595,
    height: 83.127,
    rx: 8,
    transform: "translate(1109.491 1057.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "booking-grid-logo",
    transform: "translate(1146.571 1080.087)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(17.275 0.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M98.817,57.225a2.7,2.7,0,1,1,2.7,2.71A2.7,2.7,0,0,1,98.817,57.225Z",
    transform: "translate(-45.952 -54.514)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M157.083,81.85a2.7,2.7,0,1,1,2.7,2.71A2.7,2.7,0,0,1,157.083,81.85Z",
    transform: "translate(-61.565 -61.113)",
    fill: "#499fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M35.1,76.51c-2.328,0-3.946-1.849-3.946-4.491S32.771,67.53,35.1,67.53s3.977,1.848,3.977,4.489C39.076,74.7,37.475,76.51,35.1,76.51Zm0-12.928a8.436,8.436,0,1,0,0,16.872,8.437,8.437,0,1,0,0-16.872Z",
    transform: "translate(-26.599 -56.944)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M87.751,70.269a4.021,4.021,0,0,0-.645-.907l-.149-.158.157-.15a6.759,6.759,0,0,0,.68-.848l4.347-6.462H86.864L83.6,66.8a1.274,1.274,0,0,1-1.117.408h-.744V57.65c0-1.911-1.191-2.171-2.477-2.171h-2.2l0,22.556h4.676V71.269h.438c.533,0,.9.062,1.062.351l2.579,4.868a2.594,2.594,0,0,0,2.789,1.546h3.583L89.52,73.62Z",
    transform: "translate(-40.121 -54.773)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M119.163,63.533a6.361,6.361,0,0,0-4.746,1.95l-.284.287-.1-.39a2.155,2.155,0,0,0-2.359-1.484h-2.1l.013,16.291h4.644V72.679a6.086,6.086,0,0,1,.289-1.952,3.819,3.819,0,0,1,3.761-2.853c1.449,0,2.016.765,2.016,2.742v7.1a2.155,2.155,0,0,0,2.469,2.476h2.209l-.007-10.361C124.974,65.709,122.965,63.533,119.163,63.533Z",
    transform: "translate(-48.836 -56.931)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M101.782,64.039h-2.2l.015,12.6,0,3.692h2.35c.029,0,.053,0,.083,0l1.094,0h1.089V80.32h.007l.01-13.808A2.16,2.16,0,0,0,101.782,64.039Z",
    transform: "translate(-46.156 -57.067)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M60.014,76.51c-2.328,0-3.949-1.849-3.949-4.491s1.621-4.489,3.949-4.489,3.977,1.848,3.977,4.489C63.991,74.7,62.39,76.51,60.014,76.51Zm0-12.928a8.436,8.436,0,1,0,0,16.872,8.437,8.437,0,1,0,0-16.872Z",
    transform: "translate(-33.274 -56.944)",
    fill: "#273b7d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(95.027 6.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M195.991,76.51c-2.326,0-3.949-1.849-3.949-4.491s1.622-4.489,3.949-4.489,3.979,1.848,3.979,4.489C199.97,74.7,198.367,76.51,195.991,76.51Zm0-12.928a8.437,8.437,0,1,0,8.534,8.436A8.192,8.192,0,0,0,195.991,63.583Z",
    transform: "translate(-147.465 -63.51)",
    fill: "#499fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M140.991,75.767c-2.539,0-3.443-2.215-3.443-4.291,0-.915.231-3.9,3.2-3.9,1.474,0,3.44.423,3.44,4.049C144.188,75.049,142.448,75.767,140.991,75.767ZM146.6,63.846a2.015,2.015,0,0,0-1.9.993l-.128.249-.215-.187a6.323,6.323,0,0,0-4.277-1.418c-4.342,0-7.265,3.261-7.265,8.115s3.025,8.235,7.353,8.235a5.708,5.708,0,0,0,3.572-1.046l.359-.269v.453c0,2.176-1.407,3.376-3.958,3.376a9.385,9.385,0,0,1-3.123-.576,1.38,1.38,0,0,0-1.962.937l-.369.912-.521,1.332.323.172a12.684,12.684,0,0,0,5.679,1.383c3.954,0,8.572-2.024,8.572-7.721l.017-14.941Z",
    transform: "translate(-132.814 -63.483)",
    fill: "#273b7d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(0.377 1.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M11.619,74.155l-3.78,0V69.631c0-.966.374-1.468,1.2-1.584h2.578a3.054,3.054,0,0,1,0,6.107ZM7.839,61.963V60.774c0-1.041.44-1.536,1.407-1.6H11.18a2.439,2.439,0,0,1,2.652,2.654,2.517,2.517,0,0,1-2.592,2.744h-3.4Zm8.608,4.51-.683-.384.6-.51a5.457,5.457,0,0,0,1.857-4.255c0-3.545-2.75-5.833-7.006-5.833H5.8a2.371,2.371,0,0,0-2.286,2.342V77.955H5.743c.006,0,.008,0,.009,0h5.553c4.731,0,7.785-2.575,7.785-6.564A5.48,5.48,0,0,0,16.447,66.474Z",
    transform: "translate(-3.514 -55.49)",
    fill: "#273b7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M232.1,63.605a6.4,6.4,0,0,0-4.985,2.415l-.337.426-.264-.477a4.623,4.623,0,0,0-4.4-2.365,5.894,5.894,0,0,0-4.279,1.92L217.4,66l-.169-.627a2.075,2.075,0,0,0-2.266-1.4h-1.952L213,80.2h4.435V73.04a7.967,7.967,0,0,1,.235-1.9c.424-1.731,1.587-3.593,3.542-3.406,1.206.116,1.795,1.048,1.795,2.848V80.2h4.466V73.04a6.527,6.527,0,0,1,.25-1.96c.359-1.652,1.574-3.347,3.461-3.347,1.365,0,1.87.773,1.87,2.85v7.248c0,1.64.731,2.372,2.37,2.372h2.088l0-10.36C237.512,65.706,235.69,63.605,232.1,63.605Z",
    transform: "translate(-59.65 -57.665)",
    fill: "#499fdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M179.028,74.57a6.855,6.855,0,0,1-4.434,2.028,4.337,4.337,0,0,1-4.6-4.54,4.291,4.291,0,0,1,4.36-4.6c.834,0,1.782.3,1.93.8l.022.085a1.63,1.63,0,0,0,1.58,1.2l2.43,0V67.423c0-2.8-3.563-3.817-5.961-3.817-5.128,0-8.849,3.57-8.849,8.487s3.681,8.48,8.755,8.48a9.2,9.2,0,0,0,6.819-2.923l.128-.157L179.28,74.3Z",
    transform: "translate(-46.923 -57.665)",
    fill: "#499fdd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.c7371847f432303be3af0ecbd7d2cc9e.svg";
export { ForwardRef as ReactComponent };